<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card p-3">
      <div class="card-body">
        <h2 class="card-title-desc">Create Customer Order</h2>
        <create-order-form-component v-if="isUserStaff()" @orderAction="createOrder"/>
        <customer-create-order-form-component v-else @orderAction="createOrder"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import CreateOrderFormComponent from "@/components/orders/create-order-form-component";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {routeItems} from "@/router/endpoints";
import CustomerCreateOrderFormComponent from "@/components/orders/customer-create-order-form-component";

export default {
  page: {
    title: "Create Customer Order",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {CustomerCreateOrderFormComponent, CreateOrderFormComponent, PageHeader, Layout},
  name: "create-order",
  data() {
    return {
      title: "Create Customer Order",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Create Customer Order",
          active: true
        }
      ],
    }
  },
  methods: {
    ... mapActions({
      addOrder: 'orders/addNewCustomerOrder'
    }),
    async createOrder(data){
      await this.addOrder(data).then(resp => {
        if(resp.publicId){
          successToast(`New Order added successfully`)
          this.$router.push(routeItems.customize_order_route+'/'+resp.publicId)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
